<div style="background-color: #eee; width: 100%; height: auto;">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/login' || location == '/register')"></app-footer>
</div>
